import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import TextInputField from "../../components/forms/TextInputField";
import DropDownInputField from "../../components/forms/DropDownInputField";
import Checkbox from "../../components/Checkbox";
import FormError from "../../components/forms/FormError";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import TextAreaInputField from "../../components/forms/TextAreaInputField";
import { allTags, allStatuses } from "../notes";
import styles from "./NoteForm.module.scss";

class NoteForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Save"; 

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field
              label="Status"
              name="status"
              component={DropDownInputField}
              data={allStatuses()}
              valueKey="id"
              titleKey="name"
              showBlank={false}
              serverError={errors.status}
              />

            <Field 
              label="Title"
              name="title"
              component={TextInputField}
              serverError={errors.title}
              />

            <Field 
              label="More Info"
              name="descriptionHtml"
              component={TextAreaInputField}
              serverError={errors.descriptionHtml}  
              />

            <Field
              label="Tags"
              name="tags"
              component={NoteTagFields}
              serverError={errors.tags}
              />

          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label="Delete" active={!submitting} onClick={this.props.onDelete} primary={false} show={this.props.showDelete} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
        </div>
      </form>
    )
  }
}

function NoteTagFields(props) {

  function handleClick(id) {
    let tags = props.input.value || [];
    if (tags.indexOf(id) >= 0) {
      tags = tags.filter(x => x !== id);
    } else {
      tags = tags.concat([id]);
    }
    props.input.onChange(tags);
  }

  let elements = allTags().map(tag => {
    return <Checkbox 
              key={tag.get("id")} 
              label={tag.get("name")} 
              checked={props.input.value && props.input.value.indexOf(tag.get("id")) >= 0}
              onClick={() => handleClick(tag.get("id"))} />
  })

  return (
    <>
      <tr className="field">
        <th>Tags</th>
        <td>
          <div className={styles.tags}>
            {elements}
          </div>
        </td>
      </tr>
    </>
  )
}



NoteForm.defaultProps = {
  showDelete: false
}


const ReduxForm = reduxForm({
  form: "NoteForm"
})(NoteForm);


export default ReduxForm;